import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

// The server wants only these fields; browsers add others (expirationTime)
const cleanSubscription = (json) => ({
  endpoint: json.endpoint,
  keys: { p256dh: json.keys?.p256dh, auth: json.keys?.auth },
});

export const pushApi = {
  getTypes: () => axios.get(`${API_URL}/push/types`, { headers: getHeaders() }),
  setType: (key, enabled) =>
    axios.patch(`${API_URL}/push/preferences`, { notificationType: key, enabled }, { headers: getHeaders() }),
  getPreferences: () => axios.get(`${API_URL}/push/preferences`, { headers: getHeaders() }),
  getDevices: () => axios.get(`${API_URL}/push/devices`, { headers: getHeaders() }),
  removeDevice: (id) => axios.delete(`${API_URL}/push/devices/${encodeURIComponent(id)}`, { headers: getHeaders() }),
  sendTest: () => axios.post(`${API_URL}/push/test`, {}, { headers: getHeaders() }),
  vapidKey: () => axios.get(`${API_URL}/push/vapid-public-key`, { headers: getHeaders() }),
  subscribe: (json) => axios.post(`${API_URL}/push/subscribe`, cleanSubscription(json), { headers: getHeaders() }),
  unsubscribe: (endpoint) =>
    axios.delete(`${API_URL}/push/subscribe`, { headers: getHeaders(), data: { endpoint } }),
};
